export default {
  exportRecords: 'Export Records',
  exportDateRequired: 'Select a complete date range before exporting',
  exportDateInvalid: 'Select a valid export date range of no more than 31 days',
  exportSubmitted: 'Export submitted. Download the file from Export Records when ready',
  exportFailed: 'Export failed. Please try again',
  exportRefresh: 'Refresh',
  exportDownload: 'Download',
  exportStatus: 'Export Status',
  exportProgress: 'Exported / Total',
  exportStatuses: { PENDING: 'Pending', GENERATING: 'Generating', UPLOADING: 'Uploading', SUCCEEDED: 'Completed', FAILED: 'Failed', EXPIRED: 'Expired' },
  afterSaleList: 'Aftersales Application',
  afterDetails: 'After Sale Detail',
  selectCountry: 'Select Country',
  finishCloseTime: 'Close Time',
  createdTime: 'Created Time',
  reviewedTime: 'Review Time',
  all: 'All',
  afterSaleNo: 'ASO No.',
  ticketStage: 'Ticket Stage',
  search: 'Search',
  export: 'Export',
  userId: 'Customer ID',
  pendingApprove: 'Pending Review',
  pendingReviewConfirmation: 'Pending Review Confirmation',
  sellerRejected: 'Seller Rejected',
  sellerApproved: 'Seller Approved',
  inProcessing: 'Processing',
  done: 'Done',
  cancelled: 'Cancelled',
  failed: 'Failed',
  rejected: 'Rejected',
  expectedSolution: 'Expect Solution',
  amount: 'Amount Involved',
  orderNo: 'SO No.',
  createTime: 'Create Time',
  remainingReviewTime: '{time} remaining',
  timedOut: 'Timed Out',
  merchantReviewTime: 'Review Time(Seller)',
  appealIF: 'Appeal',
  platformSolution: 'Platform Solution',
  qualityAdjustment: 'Adjusted Solution (QC)',
  closeTime: 'Close Time',
  afterSaleStatus: 'Status',
  asStats: 'AS Status',
  operation: 'Operation',
  detail: 'Detail',
  processAction: 'Process',
  days7: '7 Days',
  days30: '30 Days',
  MTD: 'MTD',
  YTD: 'YTD',
  TD: 'TD',
  userReview: 'User Approved',
  merchantReview: 'Seller Approved',
  platformArbitration: 'Platform Appeal',
  quality: 'Quality',
  returnGoods: 'Return',
  delivery: 'Delivery',
  pickUp: 'Pick Up',
  refundAndReturn: 'Refund & Return',
  refund: 'Refund',
  exchange: 'Exchange',
  repair: 'Repair',
  resend: 'Resend',
  // 详情页
  originalOrderSummary: 'Original Sale Order',
  showMore: 'Show More',
  salesOrderNo: 'Sales Order No.',
  billNo: 'Bill No.',
  paymentOrderNo: 'Payment Order No.',
  orderAmount: 'Order Amount',
  actualPaid: 'Actual Paid',
  orderTime: 'Order Time',
  payTime: 'Pay Time',
  signTime: 'Sign Time',
  originalLogistics: 'Original Logistic Info',
  track: 'Track',
  logisticsTrackNo: 'Logistics Track No.',
  afterSaleDetail: 'After-Sales Details',
  latestSolution: 'Latest Solution',
  statusLabel: 'Status',
  user: 'User',
  relatedOrderNo: 'SO No.',
  product: 'Product',
  applySolution: 'User Solution',
  applyTime: 'Apply Time',
  sellerSolution: 'Seller Solution',
  auditTime: 'Review Time',
  reachedSolution: 'Lastest Solution',
  closeType: 'Close Type',
  ticketSummary: 'Work Order Info',
  noTicketInfo: 'No ticket info',
  ticketStatus: 'Status',
  processing: 'Processing',
  pending: 'Pending',
  effectTime: 'Effective Time',
  lastUpdateTime: 'Last Update Time',
  userApplyInfo: 'User Application Information',
  faultInvolved: 'Fault Related',
  issueItem: 'Issue Item',
  dataUpdateTime: 'Data Last Updated',
  intentSolution: 'Intended Resolution',
  applyReason: 'Reason For Request',
  descriptionMedias: 'Description/Video/Photos',
  approved: 'Approved',
  review: 'Review',
  submit: 'Submit',
  orderIdNotExist: 'Order ID does not exist',
  fetchDetailFailed: 'Failed to fetch detail',
  operationSuccess: 'Operation Success',
  operationFailed: 'Operation Failed',
  afterSaleIdNotExist: 'After Sale ID does not exist',
  noDetailPage: 'Current ticket type [{type}] has no detail page',
  // 服务类型
  serviceTypeReturn: 'Refund & Return',
  serviceTypeRefund: 'Refund Only',
  serviceTypeExchange: 'Exchange',
  serviceTypeRepair: 'Repair',
  serviceTypeResend: 'Resend',
  serviceTypeDefault: 'Rejected',
  // 主状态
  statusPending: 'Pending',
  statusProcessing: 'Processing',
  statusCancel: 'Cancelled',
  statusDone: 'After Sale Completed',
  statusRejected: 'Rejected',
  statusFailed: 'After Sale Failed',
  // 步骤条
  stepApplied: 'Applied',
  stepPendingSellerAudit: 'Pending Seller Audit',
  stepSellerRejected: 'Seller Rejected',
  stepSellerAudited: 'Seller Audited',
  stepStartProcessing: 'Start Processing',
  stepAfterSaleDone: 'After Sale Completed',
  // 关闭类型
  closeArbitrationRejected: 'Arbitration Rejected',
  closeSellerRejected: 'Seller Rejected',
  // 申诉状态
  appealPending: 'Pending Arbitration',
  appealRejected: 'Rejected',
  appealDone: 'Arbitrated',
  appealDetail: 'Appeal Detail',
  appealStatus: 'Appeal Status',
  appealReason: 'Appeal Reason',
  appealTime: 'Appeal Time',
  // 工单类型
  processStoreAudit: 'Seller Review',
  processPlatformAudit: 'Platform Audit',
  processUserAudit: 'Customer Confirm',
  processReturn: 'Return Order',
  processInspection: 'QC Order',
  processRefund: 'Refund Order',
  processExchange: 'Exchange Order',
  processRepair: 'Repair Order',
  processResend: 'Resend Order',
  processDelivery: 'Delivery Order',
  processCollection: 'Pre-review Audit',
  // Ticket status
  processStatusAccepted: 'Accepted',
  processStatusInvalid: 'Invalid',
  processStatusQcReportIssued: 'QC Report Issued',
  processStatusDonePassed: 'Done(Passed)',
  processStatusPendingIssue: 'Pending Issue',
  processStatusIssuedPendingConfirm: 'Issued Pending Confirm',
  processStatusDispatched: 'Dispatched',
  processStatusRepairerSigned: 'Signed(By RepairProvider)',
  processStatusRepairDone: 'Repair Done',
  processStatusSendBack: 'Send Back',
  processStatusPlatformReceived: 'Signed By AS Agent',
  processStatusPendingShipCustomer: 'Pending Ship(Customer)',
  processStatusSigned: 'Signed',
  processStatusExpiredInvalid: 'Expired/ Invalid',
  processStatusPendingReceiving: 'Pending Receiving',
  processStatusReceived: 'Received',
  processStatusApproved: 'Approved',
  processStatusTimeoutFailure: 'Timeout or failure',
  // 补充
  productDetail: 'Product Detail',
  skuLabel: 'SKU',
  finishCloseTimeLabel: 'Close Time',
  pendingSellerApproved: 'Pending Seller Approved',
  detailMore: 'Detail >>',
  exchangeTargetInfo: 'Target (Exchange for Another) Size/Color:',
  productId: 'Product ID',
  // Delivery Note List related
  deliveryNoteList: 'After-Sales Delivery Note List',
  deliveryNoteNo: 'Delivery Note No.',
  logisticsType: 'Logistics Type',
  logisticsOrderNo: 'Logistics Order No.',
  processedBy: 'Processed By',
  effectiveTime: 'Effective Time',
  dispatchTime: 'Dispatch Time',
  logisticsArrivedTime: 'Logistics Arrived Time',
  deliveryStatus: 'Status',
  store: 'Store',
  pendingDispatch: 'Pending Dispatch',
  pendingArrived: 'Pending Arrived',
  pendingSign: 'Pending Sign',
  pendingUserSign: 'Pending Sign',
  failedTimeout: 'Failed / Timeout',
  shopOrderNo: 'Order No.',
  deliveryLogisticsNo: 'Logistics Order No.',
  platformLogistics: 'KiliExpress',
  fbm: 'FBM',
  kiliExpress: 'KiliExpress',
  arrivedTime: 'Arrived Time',
  seller: 'Seller',
  platformAgent: 'Platform Delegate',
  thirdParty: '3rd Service Provider',
  type: 'Type',
  afterRepair: 'After Repair',
  failedReturn: 'Failed & Return',
  storeId: 'Store ID',
  userPhone: 'User Phone',
  logisticsPlatform: 'Logistics Platform',
  deliveryPanel: 'Delivery Panel',
  selectLogisticsProvider: 'Please Select Logistics Provider',
  confirm: 'Confirm',
  deliverySuccess: 'Dispatched successfully',
  deliveryFailed: 'Dispatch failed',
  logisticsProvider: 'Logistics Provider',
  deliveryListAfterSaleNo: 'AS Order No.',
  deliveryListUserId: 'Customer ID',
  deliveryListAsStatus: 'AS Status',
  deliveryListDispatchAction: 'Dispatch',
  deliveryListDispatchPanel: 'Dispatch Panel',
  deliveryListDispatchBy: 'Dispatch By',
  // Outbound Logistics List Page
  outboundLogisticsList: 'Return Shipment From AfterSales Center',
  selfPick: 'Self Pickup By Seller',
  shipmentNo: 'Shipment No.',
  shipmentType: 'Processed By',
  outboundExchangeToStore: 'To Seller',
  outboundRepairToProvider: 'To Repair Provider',
  outboundRepairToPlatform: 'Back(from Repair Provider)',
  outboundSelfPickup: '(Self Pickup)',
  upstreamOrder: 'Upstream Order',
  maintenanceProvider: 'Maintenance Service Provider',
  passRequest: 'Pass Request',
  rejectRequest: 'Reject Request',
  audit: 'Audit',
  modifySolution: 'Modify Solution',
  selectSolution: 'Please Select Solution',
  refundAmount: 'Refund Amount',
  selectAuditResult: 'Please Select Audit Result',
  inputRefundAmount: 'Please Input Refund Amount',
  exceedMaxRefundAmount: 'Cannot Exceed Max Refund Amount',
  userSelected: 'User Selected',
  auditReason: 'Audit Reason',
  selectAuditReason: 'Please select an audit reason',
  photos: 'Photos',
  remark: 'Remark',
  remarkPlaceholder: 'Please enter remark',
  reviewRemark: 'Review Remark',
  reviewPhotos: 'Review Photos',
  remainingTime: 'End in',
  cancelledBy: 'Cancelled By',
  cancelledReason: 'Cancelled Reason',
  platform: 'Platform',
  logistics: 'Logistics',
  customer: 'Customer',
  system: 'System',
  afterSalesSeq: 'After Sales Seq',
  timeOut: 'Time Out',
  printListTip: 'The selected delivery note has been printed, do you want to print again?',
  cancel: 'Cancel',
  amountNum: 'Amount',
  afterSalesHistory: 'Aftersales History',
  noHistoryRecords: 'No history records',
  logisticsTrack: 'Logistics Track',
  noLogisticsRecord: 'No logistics record'
}
